import AlgorithmCalculation from './AlgorithmCalculation';

export default AlgorithmCalculation;
